import { useMemo } from 'react';
import styled from 'styled-components';
import NoDataUI from '../../inventory/NoDataUI';
import TableView from '../TableView';
import { formatUniqueIdName } from '../../../helpers/utils';
import { getSubrOverViewHeader } from '../utils';

interface ITableViewSectionProps {
  contentData: any;
  value: string;
  valueKey: string;
}

const TableViewSection = ({ contentData, value, valueKey }: ITableViewSectionProps) => {
  const overviewSectionData = useMemo(() => {
    const currentData = contentData?.data ?? [];
    if (currentData.length) {
      const dataKey = valueKey;

      const overviewData = currentData[0];
      const formattedUniqueIdName = formatUniqueIdName(dataKey);
      const mainHeader = getSubrOverViewHeader(overviewData, dataKey);
      return {
        uniqueIdName: formattedUniqueIdName,
        uniqueIdValue: value,
        mainHeader: mainHeader
      };
    }

    return null;
  }, [contentData, value, valueKey]);

  if (!overviewSectionData || !contentData || !contentData.data) {
    return (
      <Wrapper>
        <NoDataUI />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <TableView data={contentData.data} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
`;

export default TableViewSection;
